<div class="tabMobSidePadding contactUs-heading" >
    <section>
        <h1 class="pageHeading">
            Contact us
        </h1>
        <h2 class="pageHeading-h2Heading marginB8">
            {{ "uk/pages/contact/contactTitle" | lowercase | translate }}
        </h2>
    </section>

    <section aria-labelledby="contact-description" class="marginB32">
        <div *ngIf="region === regionEnum.UK">
           <p class="contactUs-title-intro">
                {{ region === regionEnum.UK 
                ? ("uk/pages/contact/contactIntro" | lowercase | translate) 
                : ("uk/pages/contact/ns/contactIntro" | lowercase | translate) }}
            </p>
        <br>
            <p class="contactUs-title-intro">
            {{ region === regionEnum.UK 
                ? ("uk/pages/contact/contactIntro1" | lowercase | translate) 
                : ("uk/pages/contact/ns/contactIntro1" | lowercase | translate) }}
            </p>

            <div class="contactUs-title topP" *ngIf="region === regionEnum.UK">
                <p class="contactUs-title-intro contactUs-title-sales">
                    {{ "uk/pages/contact/contactSales" | lowercase | translate }}
                </p>

                <p class="contactUs-title-intro">
                    {{ "uk/pages/contact/contactPhone" | lowercase | translate }}:
                    <span>
                        <a href="tel:+448445791198">+44 (0)844 579 1198</a>
                    </span>
                </p>

                <p class="contactUs-title-intro">
                    {{ "uk/pages/contact/contactEmail" | lowercase | translate }}:
                    <span>
                        <a href="mailto:usedtrucks@volvo.com">Email Used Trucks</a>
                    </span>
                </p>
            </div>
        </div>
    </section>
    <section>
        <div *ngIf="region===regionEnum.UK">
            <h3 class="pageHeading-h3Heading"> {{ "uk/components/footer/remainingWarranty" | lowercase |
                translate }}, {{ "uk/components/footer/volvoSelected" | lowercase | translate }} and {{
                "uk/pages/contact/contactSalesType" | lowercase | translate }}</h3>
        </div>
        <div class="contactUs-title topPadding">
            <volvo-sales-person [salesTeamData]="salesTeamDetails"
                [isMasterContactPage]="true"></volvo-sales-person>
        </div>
    </section>

    <section>
        <h3 class="pageHeading-h3Heading" *ngIf="region===regionEnum.UK">
            {{ "uk/pages/contact/salesEconomy" | lowercase | translate }}
        </h3>
        <div class="contactUs-title topPadding">
            <volvo-sales-person [salesTeamData]="salesTeamEconomyDetails"
            [isMasterContactPage]="true"></volvo-sales-person>
        </div>
    </section>
    <section>
        <h3 class="pageHeading-h3Heading" *ngIf="region===regionEnum.UK">
            {{ "uk/pages/contact/contactManagement" | lowercase | translate }}
        </h3>
        <div class="contactUs-title topPadding">
            <volvo-sales-person [salesTeamData]="salesTeamMangementDetails"
                [isMasterContactPage]="true"></volvo-sales-person>
        </div>
    </section>

    <section class="bottomPadding">
        <volvo-centre-navlink id="centreNavLinks"></volvo-centre-navlink>
    </section>
</div>